import React from "react";
import ErrorIcon from "@mui/icons-material/Error";

import "./ValidationError.styles.scss";
import { ErrorMessage } from "../../constants";

export const ValidationError: React.FC<{
  messages: (ErrorMessage | string)[] | string;
  position?: "left" | "center";
}> = ({ messages, position = "left" }) => {
  return (
    <>
      {typeof messages === "string" ? (
        <div className={`validation-error validation-${position}`}>
          <ErrorIcon className="icon" />
          <span>{messages}</span>
        </div>
      ) : (
        messages.map((error: ErrorMessage | string, index: number) => (
          <div
            key={index + error}
            className={`validation-error validation-${position}`}>
            <ErrorIcon className="icon" />
            <span>{error}</span>
          </div>
        ))
      )}
    </>
  );
};
